import React, {Suspense} from 'react'

import useQueryLoaderNow from '../../../../hooks/useQueryLoaderNow'
import {Loader} from '../../../../utils/relay/renderLoader'
import organizationQuery, {

} from '../../../../__generated__/OrganizationQuery.graphql'
import Organization from '../../components/OrgBilling/Organization'



const OrganizationRoot = (props) => {
  const {match} = props
  const {
    params: {orgId}
  } = match
  const queryRef = useQueryLoaderNow(organizationQuery, {orgId})
  return (
    React.createElement(Suspense, { fallback: React.createElement(Loader, null ),}, queryRef && React.createElement(Organization, { queryRef: queryRef,} ))
  )
}

export default OrganizationRoot
